import $ from 'jquery';
import Header from '../template-parts/header/header.js';

$(function(){
    const h = new Header();
});